import { Directive, Input, OnInit } from '@angular/core';

@Directive()
export abstract class MetricBaseAbstract implements OnInit {
  @Input() codes: string[] | undefined | null;

  protected abstract onRunMetric(codes: string[]): void;

  ngOnInit(): void {
    if(this.codes && !!this.codes.length) {
      this.onRunMetric(this.codes);
    }
  }
}
